import axiosInstance from 'src/utils/axios';
import localStorageAvailable from '../../utils/localStorageAvailable';
import { notify } from 'src/components/notify';

export const getPosDevices = async (user, vendor, page, page_size, search) => {
    try {
        const storageAvailable = localStorageAvailable();
        const accessToken = storageAvailable ? localStorage.getItem('accessToken') : '';

        const config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `/service/accounts_service/v1/accounts/pos/list`,
            headers: {
                authorization: `Bearer ${accessToken}`,
                user,
            },
            params: { vendor, page, page_size, search }
        };
        const response = await axiosInstance.request(config);
        return response.data;
    } catch (err) {
        console.log(err);
        return notify(err?.message || err?.issues[0]?.message)

    }
};
export const createPosDevices = async (user, data, method, url) => {
    try {
        const storageAvailable = localStorageAvailable();
        const accessToken = storageAvailable ? localStorage.getItem('accessToken') : '';

        const config = {
            method,
            maxBodyLength: Infinity,
            url,
            headers: {
                authorization: `Bearer ${accessToken}`,
                user,
            },
            data
        };
        const response = await axiosInstance.request(config);
        return response.data;
    } catch (err) {
        console.log(err);
        return notify(err?.message || err?.issues[0]?.message)

    }
};

